<template>
  <div>
    <div class="elements">
      <drag
        v-for="entry in paletteEntries"
        :key="entry.key"
        :transfer-data="entry.data"
        :class="['item', { 'item--id': entry.key === 'id' }]"
      >
        <img :src="dragIcon" width="24" height="24" alt="">
        <span>{{ entry.label }}</span>
      </drag>
    </div>
    <div v-if="extraModules.categoriesAndZones" class="zones-section">
      <span class="small-title">{{ adminText('workflowsAll.zones_182e2eb', 'Zones') }}</span>
      <div class="zones-item">
        <drag v-for="zone in zones" :key="zone" :transfer-data="getZoneData(zone)" class="item zone-item">
          <img :src="dragIcon" width="24" height="24" alt="">
          <span>{{ workflowLabel(zone) }}</span>
        </drag>
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import dragIcon from '@/assets/builder/drag.svg'

import { defaultStyles, dropData } from './builder.utils'

export default {
  name: 'builder-elements',
  mixins: [WorkflowDisplay],
  props: {
    zones: Array,
    fields: {
      type: Array,
      default: () => ([]),
    },
    extraModules: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dragIcon,
      defaultStyles,
      dropData,
    }
  },
  computed: {
    paletteEntries() {
      const fieldOrder = ['City', 'Email', 'Address', 'Country', 'Last name', 'First name', 'Postal code', 'postalCode']
      const rank = field => {
        const index = fieldOrder.indexOf(field.name)

        return index === -1 ? fieldOrder.length : index
      }
      const entries = this.fields.filter(field => field.type !== 'avatar-field')
        .slice().sort((a, b) => rank(a) - rank(b))
        .map(field => ({
          key: `field:${field.name}`,
          label: this.workflowFieldLabel(field.name),
          data: field.type === 'country' ? this.dropData.countryName : this.getCustomDropData(field),
        }))
      const add = (key, label) => entries.push({ key, label, data: this.dropData[key] })
      add('qrCode', this.adminText('workflowsAll.qr_code_abba02f', 'QR code'))
      add('customText', this.adminText('workflowsAll.text_c3328c3', 'Text'))
      add('id', this.adminText('workflowsAll.id_474ae52', 'Id'))
      add('customImage', this.adminText('workflowsAll.image_50e19fd', 'Image'))
      add('barcode', this.adminText('workflowsAll.barcode_8e54dc5', 'Barcode'))
      add('printCount', this.adminText('workflowsAll.print_count_55b3e6a', 'Print count'))
      add('rectangle', this.adminText('workflowsAll.rectangle_c158695', 'Rectangle'))
      add('oval', this.adminText('workflowsAll.oval_a4db0b5', 'Oval'))
      add('square', this.adminText('workflowsAll.builder_square', 'Square'))
      add('fullName', this.adminText('workflowsAll.full_name_eeb6920', 'Full name'))
      add('avatar', this.adminText('workflowsAll.attendee_image_220ddc6', 'Attendee image'))
      add('roundedRectangle', this.adminText('workflowsAll.rounded_rectangle_1ac087b', 'Rounded rectangle'))
      this.fields.filter(field => field.type === 'avatar-field').forEach(field => {
        entries.push({ key: `avatar:${field.name}`, label: this.workflowFieldLabel(field.name), data: this.dropData.customAvatar })
      })
      if (this.fields.some(field => field.type === 'country')) {
        add('flag', this.adminText('workflowsAll.country_flag_3dbe3ba', 'Country flag'))
        add('countryCode', this.adminText('workflowsAll.country_code_2eb6c4c', 'Country code'))
      }
      if (this.extraModules.categoriesAndZones) add('category', this.adminText('workflowsAll.category_a3c686e', 'Category'))

      return entries
    },
  },
  methods: {
    getZoneData(zone) {
      return {
        ...this.dropData.zone,
        placeholder: zone,
      }
    },
    getCustomDropData({ name, ...rest }) {
      return {
        placeholder: name,
        meta: rest,
        ...this.dropData.custom,
      }
    },
  },
}
</script>

<style scoped>
.elements {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  min-height: 48px;
  padding: 12px 8px;
  border-radius: 8px;
  background: #fff;
  color: #333;
  font: 400 16px/1.5 'Source Sans Pro', sans-serif;
  cursor: grab;
}
.item--id span { text-transform: uppercase; }
.item img { flex-shrink: 0; }
.item span { overflow-wrap: anywhere; }
.item:hover { box-shadow: inset 0 0 0 1px #0277bd; }
.item:active { cursor: grabbing; }
.zones-section { margin-top: 24px; }
.zones-item {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
  gap: 8px;
  margin-top: 8px;
}
.zone-item { justify-content: center; }
</style>
